export class LoggingService {

    public log(e: any) {
        console.debug(`Error: Received response code '${e}' from the server`)
    }
}

const _logging_service = new LoggingService();

export default _logging_service;